import React from 'react'
import PropTypes from 'prop-types'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from 'reactstrap'
import styled from 'styled-components'
import { generateButton } from '../helpers/button'

export const DiscardRequest = (props) => {
  const { open } = props
  return (
  /* eslint no-underscore-dangle: 0 */
    <div>
      <Modal
        isOpen={ open }
        toggle={ () => props.toggle() }
      >
        <HeaderForm toggle={ () => props.toggle() }>
          <HeadLabel>Cancel Request Form</HeadLabel>
        </HeaderForm>
        <ModalBody>
        Are you sure you want to discard all changes
        </ModalBody>
        <ModalFooter>
          { generateButton('discard', (type) => props.clickCancelButton(type)) }
        </ModalFooter>
      </Modal>
    </div>
  )
}

DiscardRequest.propTypes = {
  clickCancelButton: PropTypes.func,
  toggle: PropTypes.func,
  open: PropTypes.bool,
}
DiscardRequest.defaultProps = {
  clickCancelButton: () => {},
  toggle: () => {},
  open: false,
}

const HeaderForm = styled(ModalHeader)`
  font-family: 'Gotham-Bold' !important;
  font-size: 12px ;
`
const HeadLabel = styled(Label)`
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  color: #AD2624;
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/components/my-leave/form/discard-request.js